import TableAccordion from './TableAccordion';

export default TableAccordion;